import React, { useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Modal, Typography } from 'ui-kit';
import OnboardingItems from './OnboardingItems';
import { updateStore } from 'api/store';
import { getOnboardingItems } from './utils';
import './OnboardingModal.scss';
import NewStore from 'components/Dashboard/Store/StoreModal/Actions/NewStore';

export default function OnboardingModal() {
  const containerRef = useRef();
  const history = useHistory();
  const [isStoreModalOpen, setIsStoreModalOpen] = useState(false);

  const { state: { stores, products, storeId } = {} } = useLocation<{
    storeId: string;
    stores?: number;
    products?: number;
  }>();
  const isClosable = useMemo(() => Boolean(products), [products]);
  const addModalMask = useMemo(() => Boolean(products), [products]);

  const handleOnCloseModal = () => {
    updateStore(storeId, { hasClosedTutorial: true }).then(() => {
      // Forcing a window reload because there's issues with overflow on the body
      window.location.href = `/dashboard/store/${storeId}`;
    });
  };

  const handleActions = (id) => {
    switch (id) {
      case 'BACK_TO_STORE':
        handleOnCloseModal();
        break;
      case 'NEW_STORE':
        setIsStoreModalOpen(true);
        break;
      case 'IMPORT_STORES':
        history.push('/overview/partners/');
        break;
      default:
        break;
    }
  };

  const { title, description, ...onboardingItems } = getOnboardingItems(
    stores,
    products,
    handleActions,
  );

  return (
    <div className="OnboardingModal-container" ref={containerRef}>
      <Modal
        mask={addModalMask}
        className="OnboardingModal-modal"
        visible
        destroyOnClose
        maskClosable={isClosable}
        closable={isClosable}
        footer={null}
        centered
        getContainer={() => containerRef.current}
        onCancel={handleOnCloseModal}
      >
        <div className="OnboardingModal-modal-content">
          <Typography variant="h5" className="OnboardingModal-modal-content__title">
            {title}
          </Typography>
          <Typography variant="body1">{description}</Typography>
          <OnboardingItems {...onboardingItems} />
        </div>
      </Modal>
      <NewStore
        isOpen={isStoreModalOpen}
        onCancel={() => setIsStoreModalOpen(false)}
        onSuccess={(store) => history.push(`/dashboard/store/${store.id}/`)}
        getContainer={() => containerRef.current}
      />
    </div>
  );
}
